import {useFetchAppConfig} from '../../config/useFetchAppConfig.hook';
import {useRefreshToken} from '../../domain/login/hook/useRefreshToken';

export function AppInitializer({children}: {children: React.ReactNode}) {
  useRefreshToken();
  useFetchAppConfig();
  return <>{children}</>;
}
